export default __webpack_public_path__ + "app/assets/service_card_placeholder-6a1ca4fa.png";